import { Card, CardContent, CardHeader, Grid, Skeleton, Stack, SxProps, Theme, Typography } from "@mui/material";

export interface IInfoCardExtraProps {
  variant?: "elevation" | "outlined";
  stretched?: boolean;
  centered?: boolean;
  valueColor?: string;
  action?: React.ReactNode;
}

interface Props extends IInfoCardExtraProps {
  title: React.ReactNode;
  value: React.ReactNode;
  valueSubtitle?: React.ReactNode;
  cardSx?: SxProps<Theme>;
}

const styles = {
  cardHeader: {
    paddingBottom: 0,
  },
};

export const InfoCard = (props: Props) => {
  const {
    title,
    value,
    valueSubtitle,
    valueColor,
    action,
    variant,
    stretched = false,
    centered = false,
    cardSx,
  } = props;
  const baseCardStyle: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    ...(stretched ? { height: "100%", minHeight: "150px" } : undefined),
  };

  const baseCardHeaderSx: SxProps<Theme> | undefined = {
    ...(centered ? { textAlign: "center" } : undefined),
  };

  const baseCardContentSx: SxProps<Theme> | undefined = {
    ...(stretched ? { height: "100%" } : undefined),
    ...(centered ? { textAlign: "center" } : undefined),
  };
  return (
    <Card variant={variant} sx={cardSx ? { ...baseCardStyle, ...cardSx } : { ...baseCardStyle }}>
      <CardHeader
        title={<strong>{title}</strong>}
        action={action}
        titleTypographyProps={{ variant: "subtitle2" }}
        sx={baseCardHeaderSx}
      />
      <CardContent sx={baseCardContentSx}>
        <Stack direction="column" justifyContent="center" sx={baseCardContentSx}>
          <Typography variant="h4" color={valueColor}>
            {value ?? <Skeleton />}
          </Typography>
          {valueSubtitle}
        </Stack>
      </CardContent>
    </Card>
  );
};

const skeletonStyles = {
  title: {
    height: "16px",
    width: "100%",
  },
  value: {
    height: "42px",
    width: "100%",
  },
};

export const InfoCardSkeleton = () => {
  return (
    <Card>
      <CardHeader title={<Skeleton />} sx={styles.cardHeader} />
      <CardContent>
        <Skeleton variant="text" sx={skeletonStyles.value} />
      </CardContent>
    </Card>
  );
};
